import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination, FreeMode, Navigation } from "swiper";

import "./Testimonial.scss";
import { FaQuoteLeft } from "react-icons/fa";
const data = [
  {
    prof: "Founder",
    comment:
      "Ziya did a great job of meeting deadlines and communicating. We look forward to working with her on more projects in the future",
    company: "Duplessy Foundation",
  },
  {
    prof: "Project Manager",
    comment:
      "Her technical expertise and understanding of website development platforms and coding languages has helped our company to fulfill all our projects successfully and on time",
    company: "Crypto Owl",
  },
  {
    prof: "Founder",
    comment:
      "She has shown exceptional ability to rapidly learn new skills, self educate, and adapt to the changing demands of a startup environmnet",
    company: "RawConscious",
  },
];
const Testimonial = () => {
  return (
    <div className="testimonial">
      <div className="testimonial_heading">Testimonial</div>
      <Swiper
        className="testimonial_grid"
        spaceBetween={80}
        slidesPerView={1}
        loop={true}
        navigation={{
          enabled: true,
          nextEl: ".swiper_nav_button_next",
          prevEl: ".swiper_nav_button_prev",
        }}
        freeMode={{ enabled: true }}
        breakpoints={{
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
            autoplay: true,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 60,
            autoplay: false, // change this to true when more than 4 sliders :)
          },
        }}
        parallax={true}
        centeredSlides={true}
        pagination={{
          clickable: true,
          bulletActiveClass: "swiper_pagination_active_bullet",
        }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        modules={[Autoplay, Pagination, FreeMode, Navigation]}
      >
        {data.map((item, id) => {
          return (
            <SwiperSlide className="testimonial_item" key={id}>
              <div className="ti_details">
                <div className="ti_comment">{item.comment}</div>

                <div className="ti_company_info">
                  <div className="ti_prof">{item.prof},</div>
                  <div className="ti_company"> {item.company}</div>
                </div>
              </div>

              <div className="ti_quote">
                <FaQuoteLeft />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;
